import {HalContext, HalEntity, HalImage, HalPaintable} from "@cm/hal"
import {HalPainterImageCompositorRef} from "@cm/hal/hal-ref"

const COMPOSITING_FUNCTION = `
        vec4 computeColor(ivec2 targetPixel) {
            return 1.0 - texelFetch0(targetPixel);
        }
`

export class HalInvertMask implements HalEntity {
    constructor(readonly context: HalContext) {
        this.halPainterImageCompositor = this.context.createHalPainterImageCompositor(COMPOSITING_FUNCTION)
    }

    // HalEntity
    dispose(): void {
        this.halPainterImageCompositor.release()
    }

    paint(target: HalPaintable, source: HalImage) {
        this.halPainterImageCompositor.ref.paint({
            target,
            sourceImages: source,
        })
    }

    private halPainterImageCompositor: HalPainterImageCompositorRef
}
